import { classes } from 'classifizer';

import { TFormatted } from '../../../types';

import styles from './CompilerContent.module.css';
import { HighlightsEditor } from './HighlighEditor';
import { ReactNode } from 'react';

export interface ICompiledContentProps {
  entity: TFormatted;

  onClick?(): void;

  setSelection?: (
    selection: { from: number; to: number; save: (commentId: string) => void } | null,
  ) => void;

  type?: string;

  children?: ReactNode;
}

export function CompilerContentMarkup({ children }: { children?: ReactNode }): JSX.Element {
  return <div className={classes(styles['content'], 'note_content')}>{children}</div>;
}

export function CompilerContent({
  entity,
  onClick,
  setSelection,
  type = 'static',
  children,
}: ICompiledContentProps) {
  const htmlContent = entity.withTitle
    ? entity.name + entity.originalContent
    : entity.originalContent;

  if (type === 'static') {
    return (
      <div
        onClick={onClick}
        className={classes(
          styles['content'],
          'note_content',
          typeof onClick !== 'undefined' && styles['content_clickable'],
        )}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  }

  if (type === 'highlights') {
    return (
      <div
        onClick={onClick}
        className={classes(
          styles['content'],
          'note_content',
          typeof onClick !== 'undefined' && styles['content_clickable'],
        )}
      >
        <HighlightsEditor noteId={entity.id} text={htmlContent} setSelection={setSelection} />
      </div>
    );
  }

  if (type === 'in-compiler') {
    return (
      <div
        onClick={onClick}
        className={classes(
          styles['content'],
          'note_content',
          typeof onClick !== 'undefined' && styles['content_clickable'],
        )}
      >
        {children}
      </div>
    );
  }

  return null;
}
